export const PricingComponentPath = [
    "company_name",
    "pricing_component",
    "revenue_type",
    "name",
    "taxes",
    "autoReservation",
    "refundable",
    "itemMaster",
    "revenueCOA",
    "status",
    "icon",
];

export const PricingComponentHeading = (t) => [
    { title: t("Company Name"), field: "company_name" },
    { title: t("Pricing Component"), field: "pricing_component" },
    { title: t("Revenue Type"), field: "revenue_type" },
    { title: t("Component Name"), field: "name" },
    { title: t("Taxes"), field: "taxes" },
    { title: t("Reservation"), field: "autoReservation" },
    { title: t("Refundable"), field: "refundable" },
    { title: t("Item Master"), field: "itemMaster" },
    { title: t("Revenue COA"), field: "revenueCOA" },
    { title: t("Status"), field: 'status', },
    { title: "", field: 'icon' },
];

export const PricingComponentType = [
    { type: ["text"], name: "company_name" },
    { type: ["text"], name: "pricing_component" },
    { type: ["text"], name: "revenue_type" },
    { type: ["long_text"], name: "name", max_width: 250, tooltip_placement: "top" },
    { type: ["text"], name: "taxes" },
    { type: ["text"], name: "autoReservation" },
    { type: ["text"], name: "refundable" },
    { type: ["text"], name: "itemMaster" },
    { type: ["number_format"], name: "revenueCOA" },
    { type: ["status"], name: "status" },
    { type: ["more"], icon: "icon" },
];